























module.exports =
  name: 'day'
  components:
    transaction: require('./transaction.vue').default
    balance:     require('components/inside/elements/balance.vue').default
  props: ['current_date']
  data: -> { display_tooltip: false }
  computed:
    first_day: -> HM.store.state.user.userdata.first_day
    display_week_number: -> !HM.is_mobile && hm_date.format(@current_date, 'd') == @first_day + ''
    week_number: ->
      number = hm_date.getISOWeek(@current_date)
      number += 1 if @first_day == 0 # if week starts from Sunday, then display next week number (ISO week starts from Monday)
      number = 1  if number == 53 # last week is first week
      number
    transactions: ->
      @$store.state.ui.transactions.calendar.filtered_trs.filter (tr) =>
        tr.date >= @current_date && tr.date < hm_date.addDays_f(@current_date, 7)
    week_real_sum: ->
      result =
        incomes:   @$store.getters.transactions_sum(@transactions.filter (tr) -> tr.subtype == 'i')
        expenses:  @$store.getters.transactions_sum(@transactions.filter (tr) -> tr.subtype == 'e')
      result.net = result.incomes + result.expenses
      result
    week_plan_sum: ->
      not_confirmed = @transactions.filter (tr) -> tr.isUnconfirmed()
      return
        incomes:  @$store.getters.transactions_plan_sum(not_confirmed.filter (tr) -> tr.subtype == 'i')
        expenses: @$store.getters.transactions_plan_sum(not_confirmed.filter (tr) -> tr.subtype == 'e')
    has_real_sum: -> @week_real_sum.incomes != 0 || @week_real_sum.expenses != 0
    has_plan_sum: -> @week_plan_sum.incomes != 0 || @week_plan_sum.expenses != 0
    has_week_sum: ->  @has_real_sum || @has_plan_sum
  methods:
    showTooltip: ->
      @display_tooltip = true
      return unless @has_week_sum
      @$nextTick =>
        @tooltip = $(@$el).find('.el-tooltip__popper').show()
        if @tooltip.length
          @popper = new Popper($(@$el).find('.week_number_text'), @tooltip, { placement: 'bottom' })
    hideTooltip: ->
      @display_tooltip = false
      @tooltip.hide() if @tooltip
      @popper.destroy() if @popper
